import { combineReducers } from "redux";

import { statusAppController } from "../modulos/root/root.controller"
import { medicoController } from "../modulos/medico/medico.controller"
import { salaController } from "../modulos/sala/sala.controller"
import { pacienteController } from "../modulos/paciente/paciente.controller"
import { atendimentoController } from "../modulos/atendimento/atendimento.controller";
import { configPainelChamadaController } from "../modulos/configPainelChamada/confpc.controller";
import { painelController } from "../modulos/painel/painel.controller";



const statusAppState = statusAppController.reducer.reduceState
const medicoState = medicoController.reducer.reduceState
const salaState = salaController.reducer.reduceState
const atendimentoState = atendimentoController.reducer.reduceState
const pacienteState = pacienteController.reducer.reduceState
const configPainelChamadaState = configPainelChamadaController.reducer.reduceState
const painelState = painelController.reducer.reduceState


export default combineReducers({
    statusAppState,
    medicoState,
    salaState,
    pacienteState,
    atendimentoState,
    configPainelChamadaState,
    painelState

});